<template>
  <div class="elevation-1">
    <table class="v-datatable v-table theme--light planTable">
      <thead class="planHeader">
        <tr>
          <th class="limitTxtHeader">
            <div class="planHeaderCol">
              <!-- Reserved for Limit Text-->
            </div>
          </th>
          <th :class="plan.planNo === selected ? 'planSelected' : ''" v-for="(plan) in plans" :key="plan.planNo">
            <div class="planHeaderCol text-xs-center">
              <div class="ribbon" v-if="plan.premium.discPct && plan.premium.discPct > 0">
                <span class="ribbontitle">{{plan.premium.discPct}}% OFF!</span>
              </div>
              <div v-if="plan.planNo === selected" class="selectedInfo">
                <v-chip outline color="primary">
                  <v-avatar>
                    <v-icon>mdi-checkbox-marked-outline</v-icon>
                  </v-avatar>
                  Selected Plan
                </v-chip>
              </div>
              <div class="planTitle">
                {{plan.planDesc}}
              </div>
              <div class="mt-2">
                <span class="planCurr primary--text">{{currPrefix}}</span>
                <span class="planPrice primary--text">{{formatDisplayNumber(plan.premium.premiumPayable, 2)}}</span>
              </div>
              <div v-if="plan.premium.promotion">
                {{plan.premium.promotion}}
              </div>
              <div v-else>
                &nbsp;
              </div>
              <v-btn color="primary" @click.prevent="doSelectPlan(plan.planNo)">
                Buy Now!
                <v-icon right>mdi-cart</v-icon>
              </v-btn>
            </div>
          </th>
        </tr>
      </thead>
      <tbody class="planBody">
        <tr v-for="limit in limitsText" :key="limit.value" :class="limit.main? 'titleRow' : ''">
          <td>
            <div class="planCol">
              <span v-html="formatHtml(limit.label)"></span>
            </div>
          </td>
          <td v-for="planCol in plans" :key="planCol.planNo" class="text-xs-center">
            <div class="planCol">
              <template v-if="planCol.limits[limit.value]">
                <template v-if="planCol.limits[limit.value].strValue">
                  <span>{{planCol.limits[limit.value].strValue}}</span>
                </template>
                <template v-else-if="planCol.limits[limit.value].uomUN && planCol.limits[limit.value].uomUN !== ''">
                  <span>{{getUomUN(planCol.limits[limit.value].uomUN)}}</span>
                </template>
                <template v-else-if="planCol.limits[limit.value].isSI">
                  <!-- For SI, show currPrefix and format Number -->
                  <span v-if="planCol.limits[limit.value].uomAmt">{{currPrefix + formatDisplayNumber(planCol.limits[limit.value].uomAmt, 2)}}</span>
                  <span v-else>{{currPrefix + '0'}}</span>
                </template>
                <template v-else>
                  <span v-if="planCol.limits[limit.value].uomAmt">{{formatDisplayNumber(planCol.limits[limit.value].uomAmt, 2)}}</span>
                  <span v-else>0</span>
                </template>
              </template>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { formatDisplayNumber } from '@/utils/number'
import { uomUN } from '@/const/underwriting/package'

export default {
  methods: {
    formatHtml(text) {
      // Replace /r/n with html br
      return text.replace(new RegExp('\\r?\\n', 'g'), '<br />')
    },
    formatDisplayNumber(xNum, scale = 2) {
      return formatDisplayNumber(xNum, scale)
    },
    doSelectPlan(planNo) {
      const obj = {
        value: planNo,
        proceed: true
      }
      this.$emit('selectPlan', obj)
    },
    getUomUN(val) {
      if (val && uomUN[val]) {
        return uomUN[val]
      }
      return ''
    }
  },
  props: {
    plans: {
      type: Array,
      default: () => []
    },
    limitsText: {
      type: Array,
      default: () => []
    },
    selected: {
      type: String,
      default: ''
    },
    currPrefix: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
// Style in CommonPlans (ResponsivePlans need some of this css too)
</style>
